const listItems = (editor) => {

    const tempImageAttributes = {
        alt: 'Image',
        href: '',
        listimage: true
    };

    const tempListContent = [];
    const rowContent = {
    type: 'row',
    tagName: 'tr',
    attributes: {
        dataitem: 'true'
    },
    components: [
        {
        tagName: 'td',
        type: 'cell',
        components: [
            {
            type: 'image',
            attributes: tempImageAttributes,
            classes: ['list-item-image']
            }
        ],
        classes: ['list-cell-left']
        },
        {
        tagName: 'td',
        type: 'cell',
        components: [
            { tagName: 'h1', components: 'Title here', classes: ['card-title'] , attributes: {listtitle: true}},
            {
            tagName: 'p',
            components:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            classes: ['card-text'],
            attributes: {listdescription: true}
            }
        ],
        classes: ['list-cell-right']
        }
    ],

    classes: ['list-item-content','flex']
    };

    tempListContent.push(rowContent);
    tempListContent.push(rowContent);

    const tempTableContent = [
        {
            type: 'tbody',
            components: tempListContent
        }
    ];

    editor.BlockManager.add(`list-items`, {
        label: `List Posts`,
        category: 'List Items',
        content: {
          components: tempTableContent,
          type: 'table',

          attributes: {
            wabliname: 'list',
            wablitype: 'list',
            dataitems: 'true'
          }
        },

        attributes: {
          class: 'fa fa-th-list'
        }
      });

}

export default listItems;